module.exports = ".busqueda-form {\n    min-width: 150px;\n    width: 100%;\n}\n\n.busqueda-full-width {\n    width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/menu/busqueda-menu/busqueda-menu.component.css
// module id = ./src/app/components/menu/busqueda-menu/busqueda-menu.component.css
// module chunks = main